import React from "react";
import { ButtonRenderProps, ContentSection, Stack } from "sprint-common-web";

import { AncillaryComponentRenderer } from "../../../../common/components/AncillaryComponentRenderer";
import { MovieComponentRenderer } from "../../../../common/components/MovieComponentRenderer";
import { TvSeriesComponentRenderer } from "../../../../common/components/TvSeriesComponentRenderer";
import { useOnPremAssetDetails } from "../common/hooks/useOnPremAssetDetails";
import { OnPremAncillaryContentSection } from "./ancillary/OnPremAncillaryContentSection";
import {
    EditOnPremAssetContentButton,
    EditOnPremAssetContentButtonProps
} from "./edit/content/EditOnPremAssetContentButton";
import { OnPremMovieContentSection } from "./movie/OnPremMovieContentSection";
import { OnPremTvSeriesContentSection } from "./tv-series/OnPremTvSeriesContentSection";

export const OnPremContentSection: React.FunctionComponent = () => {
    const { data: assetDetails, isLoading } = useOnPremAssetDetails();

    const contentSubtype = assetDetails?.content?.subtype;

    const editContentButton: ButtonRenderProps<EditOnPremAssetContentButtonProps> = {
        render: EditOnPremAssetContentButton
    };

    if (isLoading || !assetDetails)
        return (
            <Stack>
                <ContentSection header="Content" isLoading={isLoading} style={{ height: 400 }} />
            </Stack>
        );

    return (
        <Stack>
            <ContentSection
                header="Content"
                isLoading={isLoading}
                style={{ height: 400 }}
                buttons={[editContentButton]}
            >
                <MovieComponentRenderer subtype={contentSubtype}>
                    <OnPremMovieContentSection assetDetails={assetDetails} />
                </MovieComponentRenderer>
                <TvSeriesComponentRenderer subtype={contentSubtype}>
                    <OnPremTvSeriesContentSection assetDetails={assetDetails} />
                </TvSeriesComponentRenderer>
                <AncillaryComponentRenderer subtype={contentSubtype}>
                    <OnPremAncillaryContentSection assetDetails={assetDetails} />
                </AncillaryComponentRenderer>
            </ContentSection>
        </Stack>
    );
};
